import { render, staticRenderFns } from "./CopyrightFormFilesDetails.vue?vue&type=template&id=aacc4258&scoped=true&"
import script from "./CopyrightFormFilesDetails.vue?vue&type=script&lang=js&"
export * from "./CopyrightFormFilesDetails.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightFormFilesDetails.vue?vue&type=style&index=0&id=aacc4258&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aacc4258",
  null
  
)

export default component.exports